/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnMobilePlatform } from './en-mobile-platform';
 /**
 *
 *
 * @export
 * @interface UpdateDeviceDto
 */
export interface UpdateDeviceDto {

    /**
     * Human-readable name for the device (e.g. \"iPhone\" or \"Pixel 8 Pro\")
     *
     * @type {string}
     * @memberof UpdateDeviceDto
     */
    uniqueId?: string;

    /**
     * Hardware identifier (e.g. \"iPhone13,3\")
     *
     * @type {string}
     * @memberof UpdateDeviceDto
     */
    publicKey?: string;

    /**
     * @type {string}
     * @memberof UpdateDeviceDto
     */
    name?: string;

    /**
     * @type {string}
     * @memberof UpdateDeviceDto
     */
    deviceId?: string;

    /**
     * OS version (e.g. \"ios\", \"android\")
     *
     * @type {EnMobilePlatform}
     * @memberof UpdateDeviceDto
     */
    platform?: EnMobilePlatform;

    /**
     * @type {string}
     * @memberof UpdateDeviceDto
     */
    systemVersion?: string;

    /**
     * @type {string}
     * @memberof UpdateDeviceDto
     */
    appVersion?: string;

    /**
     * @type {string}
     * @memberof UpdateDeviceDto
     */
    manufacturer?: string;
}
